export const DEVICE_PROFILE_GEYSER_V1: string = 'snn:device-profile:geyser:v1';
export const DEVICE_PROFILE_GEYSER_V2: string = 'snn:device-profile:geyser:v2';


// WEBPACK FOOTER //
// ./src/const.ts